const config = document.querySelector('[data-fo-optional-components]');
if (config) {
  const modules = JSON.parse(config.textContent);
  const requested = new Set();
  const load = root => {
    if (!(root instanceof Element || root instanceof Document)) return;
    for (const [selector, url] of Object.entries(modules)) {
      if (requested.has(selector) || !(root.matches?.(selector) || root.querySelector(selector))) continue;
      requested.add(selector);
      import(url).catch(() => requested.delete(selector));
    }
  };
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) load(node);
    if (requested.size === Object.keys(modules).length) observer.disconnect();
  });
  load(document);
  observer.observe(document.body, { childList: true, subtree: true });
}
